import { z } from 'zod'
import { queryDateTime } from '../common/query-date'

export const expensesQuerySchema = z.object({
  startDate: queryDateTime,
  endDate: queryDateTime,
})

export type ExpensesQueryDto = z.infer<typeof expensesQuerySchema>
